import { Button, Icons, InputFile, Intent, Size } from 'construct-ui';
import ViewBase from '../../views/view-base.view';

/**
 * @deprecated
 */
export default function fileInputComponent() {
  ViewBase.call(this);

  let _filename = '';
  let _pageAttributes = {};
  let _fileExist = 'N';
  let _isFileUploaded = false;
  let _fileChange = (e) => {
    const target = e.target;
    _filename = target.files[0]?.name || '';
    _fileExist = 'Y';
    _pageAttributes.onchange(target);
  }

  return {
    view: ({ attrs }) => {
      _pageAttributes = attrs;
      if (_pageAttributes.fileID && _pageAttributes.fileID != '00000000-0000-0000-0000-000000000000') {
        _fileExist = 'Y';
        _filename = _pageAttributes.fileID;
        let arr = _pageAttributes.fileID.split('.');
        if (arr.length == 2) {
          _isFileUploaded = false;
        }
        else {
          _isFileUploaded = true;
        }
      }
      else {
        _filename = '';
      }
      return [m('.col-md-12',
        m('.d-flex.justify-content-between',
          m('label.form-label',
            attrs.label,
            attrs.mandatory ? m('span', { "style": { "color": "red" } }, '*') : ''
          ),
          _filename != "" && m('.d-flex.gap-2',
            _isFileUploaded && m(Button, {
              class: "p-2",
              iconLeft: Icons.IMAGE,
              intent: Intent.PRIMARY,
              outlined: true,
              rounded: true,
              size: Size.XS,
              onclick: () => {
                attrs.onPreview(_filename);
              }
            }),
            m(Button, {
              class: "p-2",
              iconLeft: Icons.TRASH,
              intent: Intent.NEGATIVE,
              outlined: true,
              rounded: true,
              size: Size.XS,
              onclick: () => {
                _filename = "";
                attrs.onClear();
              }
            })
          )
        ),
        m(InputFile,
          {
            onchange: _fileChange,
            text: _filename,
            fluid: true,
            accept: attrs.accept || ''
          },
        ),
        attrs.validate && !attrs.isvalid &&
        m(
          'div', { "class": "invalid-feedback fs-6 pull-left", style: 'display:block;' },
          m('small', "Please select a photo")
        ),
      ),
      this.getBaseViews()];
    }
  }
}
